import type { ReactNode } from "react";
import { FEATURE_FLAGS, flagEnabled, useAuth } from "../../../hooks/useAuth";
import styles from "./BillingFlagGate.module.css";

// Billing surfaces (the Billing + Tiers & Pricing tabs) stay visible even when
// the billing_stripe flag is off, but their pages don't mount until it's on --
// so nothing is fetched (the endpoints 404 while off) and the admin sees a
// clear "enable the flag" notice instead.
export const BillingFlagGate = ({ children }: { children: ReactNode }): JSX.Element => {
  const { user } = useAuth();
  if (flagEnabled(user?.features, FEATURE_FLAGS.billingStripe)) return <>{children}</>;
  return (
    <div className={styles.notice}>
      <h2 className={styles.title}>Billing is turned off</h2>
      <p className={styles.body}>
        Enable the <code className={styles.code}>billing_stripe</code> feature flag under{" "}
        <strong>Admin → Feature Flags</strong> for billing to appear.
      </p>
    </div>
  );
};
